import React from "react";
import { wordData } from "./data";

const WorkHeading = () => {
  const { title, subtitle } = wordData;
  return (
    <div
      className="text-center my-[50px] relative z-[-1]"
      data-aos="fade-down"
      data-aos-delay="400"
    >
      <p className="font-normal text-gray-400 text-xl px-0">{title}</p>
      <p className="font-bold text-cyan-950 lg:w-[70%] lg:leading-[3rem] text-xl sm:text-2xl lg:text-4xl my-5 px-0 mx-auto">
        {subtitle}
      </p>
    </div>
  );
};

export default WorkHeading;
